







































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';
import {Project} from '@/types';
import {Action} from 'vuex-class';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    GenericButton,
    Dialog,
  },
})
export default class ProjectDelete extends Vue {
  @Prop() private project!: Project;
  @Prop() private openDialog!: boolean;

  private get prevent(): boolean {
    if (!this.project) {
      return false;
    }

    return this.project.devices_count > 0;
  }

  private async deleteProject() {
    this.$emit('closeDialog');
    this.$emit('confirmDelete');
  }
}
